// extracted by mini-css-extract-plugin
export default {"header":"ResultBlock_header__tZhm9","content":"ResultBlock_content__YCTj9","rounded":"ResultBlock_rounded__yLrjf"};